export default __webpack_public_path__ + "0d3a462.png";